import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1EmployeeRecordsList: build.query<
      ApiPortalV1EmployeeRecordsListApiResponse,
      ApiPortalV1EmployeeRecordsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/records/`,
        params: {
          assessment_period: queryArg.assessmentPeriod,
          employee: queryArg.employee,
          employee_record_value: queryArg.employeeRecordValue,
          value: queryArg.value,
        },
      }),
    }),
    apiPortalV1EmployeeRecordsCreate: build.mutation<
      ApiPortalV1EmployeeRecordsCreateApiResponse,
      ApiPortalV1EmployeeRecordsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/records/`,
        method: "POST",
        body: queryArg.employeeRecordCreateUpdate,
      }),
    }),
    apiPortalV1EmployeeRecordsRetrieve: build.query<
      ApiPortalV1EmployeeRecordsRetrieveApiResponse,
      ApiPortalV1EmployeeRecordsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/records/${queryArg.id}/`,
      }),
    }),
    apiPortalV1EmployeeRecordsUpdate: build.mutation<
      ApiPortalV1EmployeeRecordsUpdateApiResponse,
      ApiPortalV1EmployeeRecordsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/records/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.employeeRecord,
      }),
    }),
    apiPortalV1EmployeeRecordsPartialUpdate: build.mutation<
      ApiPortalV1EmployeeRecordsPartialUpdateApiResponse,
      ApiPortalV1EmployeeRecordsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/records/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedEmployeeRecordCreateUpdate,
      }),
    }),
    apiPortalV1EmployeeRecordsDestroy: build.mutation<
      ApiPortalV1EmployeeRecordsDestroyApiResponse,
      ApiPortalV1EmployeeRecordsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/records/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiPortalV1EmployeeRecordsByPeriodAndValueRetrieve: build.query<
      ApiPortalV1EmployeeRecordsByPeriodAndValueRetrieveApiResponse,
      ApiPortalV1EmployeeRecordsByPeriodAndValueRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/records/by-period-and-value/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
          employee_record_value_id: queryArg.employeeRecordValueId,
          organization_id: queryArg.organizationId,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1EmployeeRecordsListApiResponse =
  /** status 200  */ EmployeeRecordRead[];
export type ApiPortalV1EmployeeRecordsListApiArg = {
  assessmentPeriod?: number;
  employee?: number;
  employeeRecordValue?: number;
  value?: string;
};
export type ApiPortalV1EmployeeRecordsCreateApiResponse =
  /** status 201  */ EmployeeRecordCreateUpdateRead;
export type ApiPortalV1EmployeeRecordsCreateApiArg = {
  employeeRecordCreateUpdate: EmployeeRecordCreateUpdate;
};
export type ApiPortalV1EmployeeRecordsRetrieveApiResponse =
  /** status 200  */ EmployeeRecordRead;
export type ApiPortalV1EmployeeRecordsRetrieveApiArg = {
  /** A unique integer value identifying this employee record. */
  id: number;
};
export type ApiPortalV1EmployeeRecordsUpdateApiResponse =
  /** status 200  */ EmployeeRecordRead;
export type ApiPortalV1EmployeeRecordsUpdateApiArg = {
  /** A unique integer value identifying this employee record. */
  id: number;
  employeeRecord: EmployeeRecord;
};
export type ApiPortalV1EmployeeRecordsPartialUpdateApiResponse =
  /** status 200  */ EmployeeRecordCreateUpdateRead;
export type ApiPortalV1EmployeeRecordsPartialUpdateApiArg = {
  /** A unique integer value identifying this employee record. */
  id: number;
  patchedEmployeeRecordCreateUpdate: PatchedEmployeeRecordCreateUpdate;
};
export type ApiPortalV1EmployeeRecordsDestroyApiResponse = unknown;
export type ApiPortalV1EmployeeRecordsDestroyApiArg = {
  /** A unique integer value identifying this employee record. */
  id: number;
};
export type ApiPortalV1EmployeeRecordsByPeriodAndValueRetrieveApiResponse =
  /** status 200  */ {
    [key: string]: any;
  };
export type ApiPortalV1EmployeeRecordsByPeriodAndValueRetrieveApiArg = {
  /** ID of the assessment period */
  assessmentPeriodId: number;
  /** ID of the employee record value */
  employeeRecordValueId: number;
  /** ID of the organization */
  organizationId: number;
};
export type EmployeeRecord = {
  employee: number;
  value_name?: string;
  value?: string | null;
};
export type EmployeeRecordValue = {
  id: number;
  name: string;
  type_of_value: number;
};
export type EmployeeRecordValueRead = {
  id: number;
  name: string;
  type_of_value: number;
  organization: string;
};
export type EmployeeRecordRead = {
  id: number;
  employee: number;
  employee_details: string;
  value_name?: string;
  employee_record_value: EmployeeRecordValueRead;
  employee_record_value_id: number | null;
  assessment_period: string;
  value?: string | null;
  created_at: string;
  updated_at: string;
};
export type EmployeeRecordCreateUpdate = {
  employee?: number;
  employee_record_value?: number;
  assessment_period: number;
  value?: string | null;
};
export type EmployeeRecordCreateUpdateRead = {
  id: number;
  employee?: number;
  employee_record_value?: number;
  assessment_period: number;
  value?: string | null;
  created_at: string;
  updated_at: string;
};
export type PatchedEmployeeRecordCreateUpdate = {
  employee?: number;
  employee_record_value?: number;
  assessment_period?: number;
  value?: string | null;
};
export type PatchedEmployeeRecordCreateUpdateRead = {
  id?: number;
  employee?: number;
  employee_record_value?: number;
  assessment_period?: number;
  value?: string | null;
  created_at?: string;
  updated_at?: string;
};
export const {
  useApiPortalV1EmployeeRecordsListQuery,
  useApiPortalV1EmployeeRecordsCreateMutation,
  useApiPortalV1EmployeeRecordsRetrieveQuery,
  useApiPortalV1EmployeeRecordsUpdateMutation,
  useApiPortalV1EmployeeRecordsPartialUpdateMutation,
  useApiPortalV1EmployeeRecordsDestroyMutation,
  useApiPortalV1EmployeeRecordsByPeriodAndValueRetrieveQuery,
} = injectedRtkApi;
